import Client from '@/repositories/Clients/AxiosClient'
import Config from '@/repositories/Clients/AxiosDefaultConfig'
import { prepareSearchParams } from '@/libs/helper'

const resource = `${Config.basePath}/question/answer`
const topic = `${Config.basePath}/conversation-summary`

export default {
  list(payload) {
    return Client.get(`${resource}`, {
      params: prepareSearchParams(payload),
    })
  },
  update(id, payload) {
    return Client.put(`${resource}/update/${id}`, {
      ...payload,
    })
  },
  destroy(id) {
    return Client.delete(`${resource}/delete/${id}`)
  },
  download(payload) {
    return Client.get(`${resource}/download`, {
      params: payload,
    })
  },
  topicSummary(payload) {
    return Client.get(`${topic}`, {
      params: prepareSearchParams(payload),
    })
  },
  downloadTopicSummary(payload) {
    return Client.get(`${topic}/download`, {
      params: payload,
    })
  },
  enable(payload) {
    return Client.put(`${topic}/enable`, {
      ...payload,
    })
  },
  destroyTopicSummary(id) {
    return Client.delete(`${topic}/delete/${id}`)
  },
}
